import { View } from 'react-native'

import { styled } from '~/utils'

export const Toggle = styled(View, theme => {
  return {
    base: {
      width: theme.sizingExtrasmall,
      height: theme.sizingExtrasmall,
      borderRadius: theme.borderRadiusPill,
      borderWidth: theme.borderWidthNone,
      backgroundColor: theme.colorContainerFillDefault,
    },
    variants: {},
  }
})
